import ContentLayoutComponent from '../../../../../layouts/content/component/content.layout.component';
import BundleVersionController from './bundle.version.controler';

export default class BundleVersionComponent {
	constructor() {
		this.template = require('./bundle.version.view.html');
		this.controller = BundleVersionController;
		this.bindings = {
			bundle: '<',
			version: '<'
		};
	}
}

BundleVersionComponent.META = {
	name: 'singleVersion',
	state: {
        isDistributionState: true,
        name: 'singleVersion',
		url: '/bundles/source/:bundle/:version?tab',
		template: '<single-version></single-version>',
		parent: ContentLayoutComponent.META.state,
        params: {tab:'content'}
	}
};



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/version/bundle.version.component.js